import { render, staticRenderFns } from "./SlcCollabItemCounter.vue?vue&type=template&id=5cc2a4ce&"
import script from "./SlcCollabItemCounter.vue?vue&type=script&lang=ts&"
export * from "./SlcCollabItemCounter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports